<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Totensonntag</h3>
      </div>
    </div>
    <div class="section section-work-images">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-1.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-2.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-3.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-4.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-5.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-6.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-7.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-8.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-9.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-10.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-11.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-12.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-13.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-14.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/all-souls-day/all-souls-day-15.jpg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'all-souls-day',
  bodyClass: 'all-souls-day-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
